import styled from "styled-components"
import InputPhoneNew from "../shared/input/new/InputPhoneNew"
import InputText from "../shared/input/new/InputText"
import InputSelect from "../shared/input/new/InputSelect"
import InputNewAracTypeSelect from "../shared/input/new/InputNewAracTypeSelect"
import InputCaseTypeSelect from "../shared/input/new/InputCaseTypeSelect"
import InputDate from "../shared/input/new/InputDate"
import { useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import moment from "moment"
import { adminAraclarAracUpdate } from "../../features/admin2/admin2Slice"
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions"
import Btn from "../shared/button/Btn"
import dateConverter from "../../helper/dateConverter"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
        }

        .update-text{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: var(--color-main);
            text-decoration: underline;
            cursor: pointer;

        }
    }

    .main-content{
        display: flex;
        gap: 8px;

        .content-grp{
            width: 50%;
            display: flex;
            flex-direction: column;

            .content-item{
                width: 100%;
                display: flex;
                align-items: center;
                width: 100%;
                padding: 8px;
                border-radius: 5px;

                &:hover{
                    background-color: ${({theme}) => theme.secondaryBgColor};
                }

                .key{
                    width: 40%;
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                }

                .row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 54%;
                }

                .value{
                    width: 60%;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-sm);
                    display: flex;

                    .tc-dogrula-btn{
                        color: var(--color-main);
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        padding-left: 20px;
                        cursor: pointer;
                        display: flex;
                        flex-direction: row;
                        text-decoration: underline !important;

                        .tc-checked{
                            color: var(--color-green);
                            display: flex;
                            align-items: center;
                            gap: 5px;
                        }

                        .tc-checked-icon{
                            font-size: 1rem;
                        }
                    }

                    .tc-dogrula-btn-passive {
                        cursor: initial !important;
                        text-decoration: none !important;
                    }
                }

                .phone-number-sorgula{
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center !important;
        margin-top: auto;
        margin: 30px 0;
        gap: 50px;
    }
`
const statusData = [
  {
    id:1,
    text:"Aktif",
    type:"aktif"
  },
  {
    id:2,
    text:"Pasif",
    type:"pasif"
  }
]

const AdminAracDetails = () => {

    const { selectAdminArac } = useSelector((state) => state.admin2);
    const dispatch = useDispatch();

    const [isUpdateContent, setIsUpdateContent] = useState(false)

    const [phoneNumber, setPhoneNumber] = useState(selectAdminArac?.phoneNumber)
    const [plateNumber, setPlateNumber] = useState(selectAdminArac.type === "truck" ? selectAdminArac?.truckPlateNumber : selectAdminArac?.trailerPlateNumber)
    const [selectAracTuru, setSelectAracTuru] = useState(null);
    const [selectCaseType, setSelectCaseType] = useState(null)
    const [statusValue, setStatusValue] = useState(selectAdminArac?.isBelgeActive === false ? "Pasif" : "Aktif")

    const [trafikSigortasıGecerlilikTarihi, setTrafikSigortasıGecerlilikTarihi] = useState(selectAdminArac.trafikSigortasıGecerlilikTarihi)
    const [muayeneGecerlilikTarihi, setMuayeneGecerlilikTarihi] = useState(selectAdminArac.muayeneGecerlilikTarihi)
    const [kaskoGecerlilikTarihi, setKaskoGecerlilikTarihi] = useState(selectAdminArac.kaskoGecerlilikTarihi)

    const [initialCaseType ,setInitialCaseType] = useState(null)

    useEffect(() => {
      setSelectAracTuru(selectAdminArac?.truckType);
      setSelectCaseType(selectAdminArac?.trailerType)
    }, [selectAdminArac]);
    
    const handleSubmit = () => {
      const addData = {
        ...selectAdminArac,
        aktifPasif: statusValue?.type || statusValue,
        vehicleType: selectAracTuru?.name || selectAracTuru,
        trailerTypeId: selectCaseType?.id || selectAdminArac?.trailerSubTypeId,
        phoneNumber: phoneNumber,
        plateNumber: plateNumber,
        transfer: ((selectAdminArac.truckType === "Römork" || selectAdminArac.truckType === "Y.Römork") && (selectAracTuru.name !== "Römork" && selectAracTuru.name !== "Y.Römork")) || ((selectAdminArac.truckType === "Kamyon" || selectAdminArac.truckType === "Tır Takım" || selectAdminArac.truckType === "Kırkayak" || selectAdminArac.truckType === "10 Teker Kamyon" || selectAdminArac.truckType === "6 Teker Kamyon" || selectAdminArac.truckType === "Kamyonet" || selectAdminArac.truckType === "Çekici" || selectAdminArac.truckType === "Özel Amaçlı") && (selectAracTuru.name !== "Kamyon" && selectAracTuru.name !== "Tır Takım" && selectAracTuru.name !== "Kırkayak" && selectAracTuru.name !== "10 Teker Kamyon" && selectAracTuru.name !== "6 Teker Kamyon" && selectAracTuru.name !== "Kamyonet" && selectAracTuru.name !== "Çekici" && selectAracTuru.name !== "Özel Amaçlı")),
        trafikSigortasıGecerlilikTarihi: moment(trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? trafikSigortasıGecerlilikTarihi : moment(trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
        muayeneGecerlilikTarihi: moment(muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? muayeneGecerlilikTarihi : moment(muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
        kaskoGecerlilikTarihi:  moment(kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? kaskoGecerlilikTarihi : moment(kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY")
      };
      
      dispatch(adminAraclarAracUpdate(addData))
    };
  
    useEffect(() => {
      if(selectAracTuru?.name === "Çekici" || selectAracTuru === "Çekici"){
        setSelectCaseType(null)
      }
    },[selectAracTuru])

  return (
    <Container>
        <div className="top-container">
            <h4>Araç Bilgileri</h4>
            <span className="update-text" onClick={() => setIsUpdateContent(!isUpdateContent)}>{!isUpdateContent ? "Güncelle" : "Detayları Görüntüle"}</span>
        </div>
        <div className="main-content">
            <div className="content-grp">
                <div className="content-item">
                    <div className="key">Telefon Numarası:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{selectAdminArac.phoneNumber}</div>
                        :
                        <InputPhoneNew labelText="Telefon Numarası" data={phoneNumber} setData={setPhoneNumber} name={"phoneNumber"} inputWidth={"100%"} />
                    }
                </div>
                <div className="content-item">
                    <div className="key">Araç Plakası:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{plateNumber}</div>
                        :
                        <InputText
                          data={plateNumber || ""}
                          setData={(e) => setPlateNumber(e.target.value)}
                          inputWidth={"100%"}
                          labelText="Araç Plakası"
                          name={"truckPlateNumber"}
                        />
                    }
                </div>
                <div className="content-item">
                    <div className="key">Aktif/Pasif:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{selectAdminArac.isBelgeActive ? "Aktif" : "Pasif"}</div>
                        :
                        <InputSelect
                          initialOptions={statusData}
                          data={statusValue?.text || statusValue }
                          setData={setStatusValue}
                          inputWidth={"100%"}
                          labelText="Aktif/Pasif"
                          name={"statusValue"}
                        />
                    }
                </div>
                <div className="content-item">
                    <div className="key">Araç Türü:</div>
                    {
                        !isUpdateContent ? 
                            <div className="value">{selectAdminArac.truckType}</div>
                        :
                        <InputNewAracTypeSelect
                          initialOptions={AdminAracEkleOptions}
                          setInitialCaseType={setInitialCaseType}
                          data={selectAracTuru?.name || selectAracTuru}
                          setData={setSelectAracTuru}
                          inputWidth={"100%"}
                          labelText="Araç Türü"
                          name={"aracTuru"}
                        />
                        }
                </div>
                <div className="content-item">
                    <div className="key">Kasa Tipi:</div>
                    {
                        !isUpdateContent ? 
                            <div className="value">{selectAdminArac.trailerType}</div>
                        :
                        <InputCaseTypeSelect 
                        initialOptions={initialCaseType}
                        data={selectCaseType}
                        setData={setSelectCaseType}
                        inputWidth={"100%"}
                        labelText="Kasa Tipi"
                        name={"selectCaseType"}
                      />
                        }
                </div>
                <div className="content-item">
                    <div className="key">Trafik Sigortası Geçerlilik Tarihi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{trafikSigortasıGecerlilikTarihi?.replaceAll("/", ".")}</div>
                        :
                        <InputDate
                        data={moment(trafikSigortasıGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(trafikSigortasıGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : trafikSigortasıGecerlilikTarihi}
                        setData={(e) => setTrafikSigortasıGecerlilikTarihi(e.target.value)}
                        inputWidth={"100%"}
                        labelText="Trafik Sigortası Geçerlilik Tarihi"
                        name={"trafikSigortasıGecerlilikTarihi"}
                      />
                    }

                </div>
                <div className="content-item">
                    <div className="key">Muayene Geçerlilik Tarihi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{muayeneGecerlilikTarihi?.replaceAll("/", ".")}</div>
                        :
                        <InputDate
                        data={moment(muayeneGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(muayeneGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : muayeneGecerlilikTarihi}
                        setData={(e) => setMuayeneGecerlilikTarihi(e.target.value)}
                        inputWidth={"100%"}
                        labelText="Muayene Geçerlilik Tarihi"
                        name={"muayeneGecerlilikTarihi"}
                      />
                    }
                </div>
                <div className="content-item">
                    <div className="key">Kasko Geçerlilik Tarihi:</div>
                      {
                        !isUpdateContent ? 
                        <div className="value">{kaskoGecerlilikTarihi?.replaceAll("/", ".")}</div>
                        :
                        <InputDate
                          data={moment(kaskoGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(kaskoGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : kaskoGecerlilikTarihi}
                          setData={(e) => setKaskoGecerlilikTarihi(e.target.value)}
                          inputWidth={"100%"}
                          labelText="Kasko Geçerlilik Tarihi"
                          name={"kaskoGecerlilikTarihi"}
                        />
                      }
                </div>
            </div>
        </div>
        <div className="button-grp">
            {
                isUpdateContent &&
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => handleSubmit()}>Güncelle</Btn>
            }
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </Container>
  )
}

export default AdminAracDetails